"use strict";

export function initPublicationsFilters() {
	const filterDropdowns = document.querySelectorAll('.publications-filters .filter-dropdown-wrapper');
	
	if (!filterDropdowns.length) return;

	filterDropdowns.forEach(wrapper => {
		const button = wrapper.querySelector('.filter-dropdown-btn');
		const dropdownItems = wrapper.querySelectorAll('.dropdown-item');
		const icon = button.querySelector('.dropdown-icon');
		
		if (!button || !dropdownItems.length) return;

		dropdownItems.forEach(item => {
			item.addEventListener('click', (e) => {
				e.preventDefault();
				
				// Remove active class from all items in this dropdown
				dropdownItems.forEach(i => i.classList.remove('active'));
				
				// Add active class to clicked item
				item.classList.add('active');
				
				// Update button text (preserving the icon if it exists)
				const selectedText = item.textContent.trim();
				
				if (icon) {
					// If button has icon, update only the text node
					const textNode = Array.from(button.childNodes).find(node => node.nodeType === Node.TEXT_NODE);
					if (textNode) {
						textNode.textContent = selectedText;
					}
				} else {
					// If no icon, just update the whole button text
					button.textContent = selectedText;
				}
				
				// Get the filter value for potential filtering logic
				const filterValue = item.getAttribute('data-filter');
				console.log('Selected filter:', filterValue);
				
				// TODO: Add your filtering logic here
				// filterPublications(filterValue);
			});
		});
	});

	// Clear filters button
	const clearButton = document.getElementById('clearFilters');
	if (clearButton) {
		clearButton.addEventListener('click', () => {
			// Reset all dropdowns to their first option
			filterDropdowns.forEach(wrapper => {
				const button = wrapper.querySelector('.filter-dropdown-btn');
				const firstItem = wrapper.querySelector('.dropdown-item');
				const icon = button.querySelector('.dropdown-icon');
				
				if (!button || !firstItem) return;
				
				// Remove active from all items
				wrapper.querySelectorAll('.dropdown-item').forEach(item => {
					item.classList.remove('active');
				});
				
				// Set first item as active
				firstItem.classList.add('active');
				
				// Reset button text
				const defaultText = firstItem.textContent.trim();
				
				if (icon) {
					const textNode = Array.from(button.childNodes).find(node => node.nodeType === Node.TEXT_NODE);
					if (textNode) {
						textNode.textContent = defaultText;
					}
				} else {
					button.textContent = defaultText;
				}
			});
			
			console.log('Filters cleared');
			// TODO: Add your clear filters logic here
			// showAllPublications();
		});
	}
}
